module.exports = __webpack_public_path__ + "static/media/check@3x.4c160965.png";


//////////////////
// WEBPACK FOOTER
// ./src/custom/livres/img/check@3x.png
// module id = 171
// module chunks = 0